<template>
  <div class="product-section-1">

    <div class="main-container">

      <logo-header
        :logo-asset="departmentware"
      />

      <div class="title-container-1">
        <lead-title1
          main-title="BETTER SOFTWARE"
        />
      </div>

      <div class="title-container-2">
        <lead-title2
          main-title="FOR"
          sub-title="PUBLIC SAFETY"
        />
      </div>

      <info-section1/>

      <!--      <info-section2/>-->

      <!--      <product-title2-->
      <!--        main-title="QM"-->
      <!--        sub-title="- Quartermaster"-->
      <!--      />-->

      <!--      <description-title-->
      <!--        main-title="Track Use of Force, Vehicle Persuits and Review Body Cam"-->
      <!--        sub-title="ON DEMAND"-->
      <!--      />-->

      <!--      <info-section3/>-->
    </div>


  </div>
</template>

<script>
import LogoHeader from "../components/LogoHeader";
import LeadTitle2 from "../components/sideMenu/LeadTitle2";
import LeadTitle1 from "../components/sideMenu/LeadTitle1";
import InfoSection1 from "./InfoSection1";
import InfoSection2 from "./InfoSection2";
import ProductTitle2 from "../components/productComponents/ProductTitle2";
import DescriptionTitle from "../components/productComponents/DescriptionTitle";
import InfoSection3 from "./InfoSection3";

export default {
  name: 'ProductSection1',
  components: {
    InfoSection3,
    DescriptionTitle, ProductTitle2, InfoSection2, InfoSection1, LeadTitle1, LeadTitle2, LogoHeader
  },

  data: () => ({
    departmentware: require('../assets/logos/departmentware-logo.svg'),
  })
}
</script>

<style lang="scss">
@import "ProductSection1.scss";
</style>
